// extracted by mini-css-extract-plugin
export default {"root":"Page_root__HewPl","content":"Page_content__5m9gB","scrollingDisabled":"Page_scrollingDisabled__e9Pt3"};